module.exports = __webpack_public_path__ + "static/img/index5.2148f4f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index5.gif
// module id = rBcW
// module chunks = 0